import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ToastProvider } from "./contexts/ToastContext";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Login from "./components/Auth/Login";
import PrivateRoute from "./components/PrivateRoute";
import Users from "./components/User/Users";
import Premises from "./components/Premise/Premises";
import VerifyEmail from "./components/Auth/VerifyEmail";
import ForgotPassword from "./components/Auth/ForgotPassword";
import OtpVerification from "./components/Auth/OtpVerification";
import ChangePassword from "./components/Auth/ChangePassword";
import UserCheckInOut from "./components/User/UserCheckInOut.js";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // const token = sessionStorage.getItem('authToken');
    const token = localStorage.getItem("authToken");
    // console.log("Token found:", token);
    setIsAuthenticated(!!token);
    // console.log = () => {};
  }, []);

  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/signin" />} />
            <Route path="/email/verify/:id/:hash" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp-verification" element={<OtpVerification />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/signin" element={<Login />} />
            {/* Premises Routes  */}
            <Route
              path="/premises"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Premises />
                </PrivateRoute>
              }
            />
            {/* Users Routes  */}
            <Route
              path="/users"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <Users />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/chechkInOut"
              element={
                <PrivateRoute isAuthenticated={isAuthenticated}>
                  <UserCheckInOut />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
};

export default App;
